"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Report = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var store_1 = require("../../../store");
var DataGrid_1 = require("../components/DataGrid");
var ImageGrid_1 = require("../components/ImageGrid");
var ImageWithTitle_1 = require("../components/ImageWithTitle");
var TitleBar_1 = require("../components/TitleBar");
var DataExtractor_1 = require("../DataExtractor");
var ReportHelpers_1 = require("../ReportHelpers");
var ReportBase_1 = require("./ReportBase");
var Report = /** @class */ (function (_super) {
    tslib_1.__extends(Report, _super);
    function Report(poles) {
        return _super.call(this, poles) || this;
    }
    Report.prototype.buildPDF = function () {
        var _this = this;
        this.poles.forEach(function (pole, i) {
            var _a;
            var job = store_1.AppStore.Tag.get(pole.jobId);
            var fullImages = [];
            var imageGroups = {};
            var tagArr = [];
            var subformArray = [];
            // Title
            _this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, _this.poles.length));
            // Data grid of items outside of subforms
            pole.forEachField(function (field) {
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        var extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldSubForm) {
                        subformArray.push.apply(subformArray, (0, ReportHelpers_1.extractSubforms)(pole, field, _this.images));
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        var captures = field.getCaptures();
                        captures.forEach(function (capture) {
                            var _a;
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                _this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                var imgReference = { reference: imageReferenceString };
                                // If a capture has measurements, then it has the timestamp built into the photo
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    fullImages.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, imgReference));
                                }
                                else {
                                    imgReference.timeStamp = new Date(capture.createdAt);
                                }
                                if (!imageGroups[field.schema.displayName]) {
                                    imageGroups[field.schema.displayName] = [];
                                }
                                (_a = imageGroups[field.schema.displayName]) === null || _a === void 0 ? void 0 : _a.push(imgReference);
                            }
                        });
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldImage) {
                        var captures = field.getCaptures();
                        captures.forEach(function (capture) {
                            var _a;
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                _this.images[imageReferenceString] = capture.medium.url;
                                if (!imageGroups[field.schema.displayName]) {
                                    imageGroups[field.schema.displayName] = [];
                                }
                                (_a = imageGroups[field.schema.displayName]) === null || _a === void 0 ? void 0 : _a.push({ reference: imageReferenceString, timeStamp: new Date(capture.createdAt) });
                            }
                        });
                    }
                }
            });
            _this.nodes.push(new DataGrid_1.DataGrid(tagArr));
            _this.nodes.push(new ImageGrid_1.ImageGrid(imageGroups));
            // Subforms
            subformArray.forEach(function (subform) {
                _this.nodes.push(subform);
            });
            // Full size composite images
            (_a = _this.nodes).push.apply(_a, fullImages);
        });
    };
    return Report;
}(ReportBase_1.ReportBase));
exports.Report = Report;
//# sourceMappingURL=Report.js.map